import React, { Fragment } from 'react';
import { Col, Card, CardBody, Form, CardHeader } from 'reactstrap';
import Dropzone from 'react-dropzone-uploader';
import { SingleFileUpload } from '../../../Constant';
import { H5 } from '../../../AbstractElements';
import { useTranslation } from 'react-i18next';

const Dropzone1 = (props) => {
  const { getUploadParams = '', handleChangeStatus = '', accept, placeholder, multi, noOfFiles } = props;
  const { t } = useTranslation();
  return (
    <Fragment>
      <Col sm="12">
            <Form>
              <div className="dz-message needsclick">
                <Dropzone
                  getUploadParams={''}
                  onChangeStatus={handleChangeStatus}
                  maxFiles={noOfFiles ?? 1}
                  accept={accept ?? "image/*,application/pdf"}
                  multiple={multi ?? false}
                  canCancel={false}
                  inputContent={placeholder ?? t("Drop A File")}
                  styles={{
                    dropzoneActive: { borderColor: '#EB0A1E' },
                    dropzone: { borderColor: '#EB0A1E', borderWidth: '2px' },
                  }}
                />
              </div>
            </Form>
      </Col>
    </Fragment>
  );
};

export default Dropzone1;
